import { type PropsWithChildren } from 'react';

import { Flex } from '../../layouts/flex/Flex.js';

/**
 * The actions of the FeatureHighlight.
 * @internal
 */
export const Actions = ({ children }: PropsWithChildren) => {
  return (
    <Flex
      flexDirection="row"
      justifyContent="flex-end"
      alignItems="center"
      gap={8}
      paddingBottom={8}
    >
      {children}
    </Flex>
  );
};

Actions['displayName'] = 'FeatureHighlight.Actions';
